///? Default IMPORTS

import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

///? Service IMPORTS

import { updatePackageStatusThunk } from "../../redux/packageTrackerRedux/Action";
import { getOrderDetailsThunk } from "../../redux/NewOrderDetails/action";
import { getMedDetailsThunk } from "../../redux/newCheckerRedux/Action";

///? Component & Styling IMPORTS

import { Base64func } from "../../components/Base64Func/Base64func";
import { Button, Divider, Input, message, Modal, Table } from "antd";
import OfflinePage from "../OfflinePage/OfflinePage";
import OrderDetails from "../../components/OrderDetailSection/OrderDetails";
import BarcodeScanner from "../../components/BarcodeScanner/BarcodeScanner";
import { FiSearch } from "react-icons/fi";
import { FooterButtons } from "../PickerOrder/PickerOrderPage/PickerOrderPage.styled";
import { GiThermometerCold } from "react-icons/gi";
import { ColdChainText } from "./ColdChain.styled";
import { warehouseId } from "../../constants";

export class ColdChainPage extends Component {
  state = {
    currentOrderId: null,
    currentOrderData: null,
    medData: null,
    currentBoxId: null,
    serviceLoading: false,
    selectedRowKeys: [],
    isColdChainModalOpen: false,
    currentSelectedMedicine: null,
    markedColdStorage: false,
    coldChainProductCodes: null,
    allMedDetails: [],
  };

  componentDidMount = () => {
    //? Getting order ID from url

    let currPath = window.location.href;

    let currPathArr = currPath.split("/");

    let orderValue = "";

    currPathArr.map((item) =>
      item.includes("orderId") ? (orderValue = item.split("=")[1]) : ""
    );

    this.setState(
      {
        currentOrderId: Base64func(orderValue, "decode"),
        serviceLoading: true,
      },
      () => {
        this.props
          .getMedDetailsThunk({
            access_token: this.props.access_token,
            orderId: this.state.currentOrderId,
            history: this.props.history,
          })
          .then(() => {
            this.setState(
              {
                allMedDetails: this.props.checkerDetails.allMedDetails
                  ?.productSubsMappingList,
              },
              () => {
                let data = {
                  orderId: this.state.currentOrderId,
                  warehouseId: warehouseId,
                  access_token: this.props.access_token,
                  history: this.props.history,
                };

                this.props.getOrderDetailsThunk(data).then(() => {
                  this.setState(
                    {
                      currentOrderData: this.props.newOrderDetails
                        .newOrderDetailsSuccess,
                      serviceLoading: this.props.newOrderDetails.isLoading,
                    },
                    () => {
                      if (this.props.newOrderDetails?.newOrderDetailsSuccess) {
                        let productCodeList = [];

                        let productCodeListMed = [];

                        let missingMedicineDetails = [];

                        let coldChainDetails = [];

                        this.props.newOrderDetails?.newOrderDetailsSuccess?.missingMedicineDetails?.map(
                          (e) => {
                            if (!productCodeListMed.includes(e.productCode)) {
                              productCodeListMed.push(e.productCode);
                              let tempArray = [];

                              this.props.newOrderDetails.newOrderDetailsSuccess.missingMedicineDetails?.map(
                                (f) => {
                                  if (f.productCode == e.productCode) {
                                    tempArray.push(f);
                                  }
                                }
                              );

                              let medicineDetails = {};
                              medicineDetails.name = e.name;
                              medicineDetails.medIssue = false;
                              medicineDetails.productCode = e.productCode;
                              medicineDetails.orderId = e.orderId;
                              medicineDetails.batches = tempArray;

                              missingMedicineDetails.push(medicineDetails);
                            }
                          }
                        );

                        this.state.allMedDetails?.map((f) => {
                          if (
                            Object.keys(
                              this.props.newOrderDetails?.newOrderDetailsSuccess
                                ?.coldChainProductMap
                            ).includes(f.subsProductCd.split(" ")[0])
                          ) {
                            coldChainDetails.push(f.name);
                          }
                        });

                        let medicineList = [];
                        this.state.allMedDetails?.map((e) => {
                          if (
                            !productCodeList.includes(e.subsProductCd) &&
                            e.medActive
                          ) {
                            productCodeList.push(e.subsProductCd);
                            let medicineDetails = {};
                            medicineDetails.name = e.subsMedName;
                            medicineDetails.medIssue = false;
                            medicineDetails.productCode = e.subsProductCd;
                            medicineDetails.orderId = this.state.currentOrderId;
                            medicineDetails.qty = e.subsQuantity;
                            // medicineDetails.batches = tempArray;

                            medicineList.push(medicineDetails);
                          }
                        });

                        if (
                          JSON.parse(localStorage.getItem("pickerFlow")) ===
                          true
                        ) {
                          medicineList = medicineList.sort((a, b) =>
                            a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1
                          );
                        } else if (
                          JSON.parse(localStorage.getItem("pickerFlow")) ===
                          false
                        ) {
                          medicineList = medicineList.sort((a, b) =>
                            a.name.toLowerCase() < b.name.toLowerCase() ? 1 : -1
                          );
                        }

                        this.setState(
                          {
                            medData: this.filterByQty(medicineList),
                            notSelectedMed: medicineList,
                            missingMedData: missingMedicineDetails,
                            coldChainProductCodes: coldChainDetails,
                          },
                          () => {
                            this.setState({
                              selectedMed: this.state.medData[0],
                              currentBoxId: this.state.currentOrderData
                                .boxNumber,
                              medReasonData: this.state.currentOrderData.reasonMasterList?.filter(
                                (i) =>
                                  i.name === "PICKER_REASON" &&
                                  i.active === true
                              ),
                            });
                          }
                        );
                      } else if (
                        this.props.newOrderDetails?.newOrderDetailsError
                      ) {
                        message.error(
                          this.props.newOrderDetails?.newOrderDetailsError
                        );

                        this.setState({
                          serviceLoading: this.props.newOrderDetails.isLoading,
                        });

                        setTimeout(() => {
                          this.props.history.push("/coldchain_dashboard");
                        }, 500);
                      }
                    }
                  );
                });
              }
            );
          });
      }
    );
  };

  getQty = (batch) => {
    let qty = 0;
    for (let i in batch) {
      let med = batch[i];
      qty = qty + med.ogQty;
    }
    return qty;
  };

  filterByQty = (medList) => {
    let finalArr = [];
    finalArr = medList.sort((a, b) => b.qty - a.qty);
    return finalArr;
  };

  changeBoxModal = (value) => {
    this.setState({ showScannerScreen: value });
  };

  updateBoxId = (value) => {
    this.setState({ currentBoxId: value, showScannerScreen: false });
  };

  coldChainMarkFunc = (packageStatusId) => {
    message.loading("Loading...", 0);
    let data = {
      packageStatusId: packageStatusId,
      awbNoPrinted: false,
      orderId: this.state.currentOrderId,
      history: this.props.history,
    };
    this.props
      .updatePackageStatusThunk(data, this.props.access_token)
      .then(() => {
        if (this.props.pdf?.updatePackageSuccess) {
          message.success(this.props.pdf?.updatePackageSuccess?.OK);
          this.props.history.push("/coldchain_dashboard");
        } else {
          message.error(this.props.pdf?.updatePackageError);
        }
      });
  };

  ////? Table search filter
  getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={(node) => {
            this.searchInput = node;
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => this.handleSearch(selectedKeys, confirm)}
          style={{ width: 188, marginBottom: 8, display: "block" }}
        />
        <Button
          type="primary"
          onClick={() => this.handleSearch(selectedKeys, confirm)}
          //  icon="search"
          size="small"
          style={{ width: 90, marginRight: 8 }}
        >
          Search
        </Button>
        <Button
          onClick={() => this.handleReset(clearFilters)}
          size="small"
          style={{ width: 90 }}
        >
          Reset
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <FiSearch style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => this.searchInput.select());
      }
    },
    //  render: (text) => (
    //    <Highlighter
    //      highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
    //      searchWords={[this.state.searchText]}
    //      autoEscape
    //      textToHighlight={text.toString()}
    //    />
    //  ),
  });

  handleSearch = (selectedKeys, confirm) => {
    confirm();
    this.setState({ searchText: selectedKeys[0] });
  };

  handleReset = (clearFilters) => {
    clearFilters();
    this.setState({ searchText: "" });
  };

  // - Ends //

  // coldChainModal = (value) => {
  //   this.setState({
  //     isColdChainModalOpen: true,
  //     currentSelectedMedicine: value,
  //   });
  // };

  render() {
    const columns = [
      {
        title: "Medicine Name",
        dataIndex: "name",
        key: "name",
        ...this.getColumnSearchProps("name"),
        render: (text) => {
          return {
            children: this.state.coldChainProductCodes.includes(text) ? (
              <ColdChainText>
                <GiThermometerCold /> {text}
              </ColdChainText>
            ) : (
              <span style={{ color: "#000", fontWeight: 600 }}>{text}</span>
            ),
          };
        },
      },

      {
        title: "QTY",
        dataIndex: "qty",
        key: "qty",
        sorter: (a, b) => a.qty - b.qty,
        render: (text) => {
          return {
            children: <span>{text}</span>,
          };
        },
      },
    ];

    return this.props.isOnline ? (
      <div className="centerScreen">
        <OrderDetails
          orderId={this.state.currentOrderId}
          customerName={this.state.currentOrderData?.customerName}
          invoiceDate={this.state.currentOrderData?.invoiceDate}
          paymentType={this.state.currentOrderData?.paymentType}
          orderValue={this.state.currentOrderData?.orderValue}
          // boxId={this.state.currentBoxId}
          // updateBox={this.changeBoxModal}
          isLoading={this.state.serviceLoading}
        />

        {this.state.showScannerScreen && (
          <BarcodeScanner
            scan={this.state.showScannerScreen ? true : false}
            camera={this.state.showScannerScreen ? true : false}
            orderId={this.state.currentOrderId}
            history={this.props.history}
            currentBoxId={this.state.currentBoxId}
            redirectMissing="MissingZone"
            getBoxId={this.updateBoxId}
          />
        )}

        <Divider>Medicine Details</Divider>
        <br />

        <Table
          dataSource={this.state.medData?.length > 0 ? this.state.medData : []}
          columns={columns}
          bordered
          loading={!this.state.currentOrderData}
          pagination={this.state.medData && this.state.medData.length > 10}
          scroll={{ x: 400 }}
        />

        {/* <Modal
          title={`Mark Medicine : ${this.state.currentSelectedMedicine} as cold chain ?`}
          visible={this.state.isColdChainModalOpen}
          // centered
          onOk={this.markOrderColdChain}
          onCancel={() => this.setState({ isColdChainModalOpen: false })}
        /> */}

        <FooterButtons>
          <button
            className="bbtn-sec"
            onClick={() => this.coldChainMarkFunc(142)}
          >
            Cancel
          </button>
          <button className="bbtn" onClick={() => this.coldChainMarkFunc(265)}>
            Accept
          </button>
        </FooterButtons>
      </div>
    ) : (
      <OfflinePage />
    );
  }
}

const mapStateToProps = (state) => ({
  access_token: state.authReducer?.AuthData?.data?.access_token,
  userInfo: state.authReducer?.AuthData?.userDTO,
  pickerDetails: state.pickerorderReducer,
  isOnline: state.statusReducer?.isOnline,
  pdf: state.packageTrackerReducer,
  newOrderDetails: state.newOrderDetailsReducer,
  checkerDetails: state.newCheckerOrderReducer,
});

const mapDispatchToProps = {
  updatePackageStatusThunk,
  getOrderDetailsThunk,
  getMedDetailsThunk,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ColdChainPage)
);
